import { createSlice } from "@reduxjs/toolkit";

const INIT_STATE = {
  inProgressCount: 0 as number
};

const ActivityDashboardSlice = createSlice({
  name: "ActivityDashboardSlice",
  initialState: INIT_STATE,
  reducers: {
    setInProgress(state, action) {
      state.inProgressCount = action.payload;
    },
    setResetState() {
      return INIT_STATE;
    }
  }
});

export default ActivityDashboardSlice;

export const ActivityDashboardSliceActions = ActivityDashboardSlice.actions;
